import { render, staticRenderFns } from "./MaintanceReasonList.vue?vue&type=template&id=143e6d96"
import script from "./MaintanceReasonList.vue?vue&type=script&lang=js"
export * from "./MaintanceReasonList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports